import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, Label, Container, Spinner, Modal, ModalHeader, ModalBody, FormGroup, Input } from "reactstrap";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import { AvForm, AvField } from "availity-reactstrap-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import { BaseUrl } from "../../helpers/Baseurl"
import { toTitleCase } from "../../helpers/methods";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom"
import { createSlugfromName, getDifferenceInDays } from "../../helpers/methods";


import HotelsDetail from "./HotelsDetail";
import VehicleDetail from "./VehicleDetail";
import ActivityDetail from "./ActivityDetail";
import PaxDetail from "./PaxDetail";
import DestinationDetail from "./DestinationDetail";
import PackageCost from "./PackageCost";
import ActivityLog from "./ActivityLog";
import styled from 'styled-components';

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

function toTitleCaseNew(str) {
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
  
const CustomSelect = styled.div`
    .select2-selection {
        text-transform: none;
    }
`;
const PackegeTypeGroup = [
    {
        label: "Packege Type",
        options: [
            { label: "Budget", value: "Budget" },
            { label: "Standard", value: "Standard" },
            { label: "Deluxe", value: "Deluxe" },
            { label: "Premium", value: "Premium" },
            { label: "Platinum", value: "Platinum" },
        ]
    }
];
const StatusGroup = [
    {
        label: "Itinerary Status",
        options: [
            { label: "Processing", value: "processing" },
            { label: "Under Discussion", value: "under discussion" },
            { label: "Tour Booked", value: "tour booked" },
            { label: "Tour In Progress", value: "tour in progress" },
            { label: "Tour Completed", value: "tour completed" },
            { label: "Tour Canceled", value: "tour canceled" },

        ]
    }
];

class ItineraryDetail extends Component {
    childRef = React.createRef();
    
    _isMounted = false;
    constructor(props) {
        super(props);
        this.obj = JSON.parse(localStorage.getItem("authUser"))
        if (!this.obj) {
            this.props.history.push('/logout')
        } else if (!validateToken(this.obj.access)) {
            this.props.history.push('/logout')
        }
        if (!has_Permission(this.obj.user, 1, 'edit')) {
            this.props.history.push('/itineraries')
        }
        this.state = {

            itinerary: [],
            is_disabled: false,
            loading: false,
            selectedStartDate: null,
            selectedendDate: null,
            LocationsGroup: [],
            DestinationsLocationGroup: [],
            DestinationGroup: [],
            selectedDestinations: [],
            selectedVisitingLocation: [],
            UsersGroup: [],
            selectedPickLocation: { label: "Select Pickup Location", value: null },
            selectedDropLocation: { label: "Select Drop Off Location", value: null },
            selectedPackegeType: { label: "Budget", value: "Budget" },
            selectedStatus: { label: "Processing", value: "processing" },
            selectedUser: { label: "", value: "" },
            vehicle_total: 0,
            hotel_total: 0,
            activity_total: 0,
            is_load: false,
            bookingDate: null, // Updated field name
            isTourBookedConfirmed: false,

        };

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "false",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
        }

        this.onLocationInputChange = this.onLocationInputChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.loadDestinationsLocationData = this.loadDestinationsLocationData.bind(this)
        this.SaveItineraryData = this.SaveItineraryData.bind(this)
        this.handleActivityTotal = this.handleActivityTotal.bind(this)
        this.handleHotelTotal = this.handleHotelTotal.bind(this)
        this.handleVehicleTotal = this.handleVehicleTotal.bind(this)
        this.tog_payment_url = this.tog_payment_url.bind(this)
        this.handlePaymentUrlSubmit = this.handlePaymentUrlSubmit.bind(this)
        this.sendNotification = this.sendNotification.bind(this)
        // this.fetchHotelData = this.fetchHotelData.bind(this);
    }

    tog_payment_url() {
        this.setState(prevState => ({
            model_payment_url: !prevState.model_payment_url
        }));
        this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    componentWillUnmount() {
        // this._isMounted = false;
        this.setState = (state, callback) => {
            return;
        };
    }

    componentDidCatch() {
        this.props.history.push('/itineraries')
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.loadDestinationData('?parent=null')
        await this.loadLocationData(`${BaseUrl}/api/locations/location/locations/`)
        await this.loadData()
        await this.loadAllUsersData()
        // await this.fetchHotelData();
    }

    async loadData() {
        let id = this.props.match.params.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        await fetch(`${BaseUrl}/api/itineraries/itineraries/${id}/`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    if (data.is_template) {
                        this.props.history.push(`/template-detail/${data.id}`)
                    }
                    console.log(data,"data")
                    let itinerary_data = data
                    let selectedDestinations = []
                    let selectedVisitingLocation = []
                    let detinies = itinerary_data.destinations
                    for (let i = 0; i < detinies.length; i++) {
                        selectedDestinations.push({ label: detinies[i].name, value: detinies[i].id })
                    }
                    let places = itinerary_data.places
                    for (let i = 0; i < places.length; i++) {
                        selectedVisitingLocation.push({ label: places[i].name, value: places[i].id })
                    }
                    let selectedPickLocation = { label: itinerary_data.pick_up_location.name, value: itinerary_data.pick_up_location.id }
                    let selectedDropLocation = { label: itinerary_data.drop_off_location.name, value: itinerary_data.drop_off_location.id }
                    let selectedPackegeType = { label: itinerary_data.packege, value: itinerary_data.packege }
                    let selectedStatus = { label: toTitleCaseNew(itinerary_data.status), value: itinerary_data.status }
                    let selectedStartDate = new Date(itinerary_data.start_date)
                    let selectedendDate = new Date(itinerary_data.end_date)
                    // let selectedBookingDate = new Date(itinerary_data.created);
                    let tourBookedDate = null;
                    let bookingDate = itinerary_data.booking_date 
                    ? new Date(itinerary_data.booking_date) 
                    : null;
                    let selectedUser = { label: itinerary_data.created_by.first_name + " " + itinerary_data.created_by.last_name, value: itinerary_data.created_by.id }
                    let pax =  itinerary_data.pax
                    let destinations = []
                    for (let i = 0; i < itinerary_data.destinations.length; i++) {
                        destinations.push(itinerary_data.destinations[i].id)
                    }
                    this.loadDestinationsLocationData(destinations.toString())
                    document.title = `Edit ${itinerary_data.title} | Planmans`
                    if (this._isMounted) {
                        this.setState({
                            itinerary: itinerary_data, selectedPackegeType, selectedPickLocation, selectedVisitingLocation,
                            selectedDropLocation, selectedDestinations, selectedStatus, selectedStartDate,
                            selectedendDate, selectedUser, pax, tourBookedDate,bookingDate, isTourBookedConfirmed: itinerary_data.status === "tour booked",
                        })
                    }
                    
                },

                (error) => {
                    toastr.error("Somthing Went Wrong")
                    this.props.history.push('/itineraries')
                }
                
            )
            

    }


      

    async loadDestinationsLocationData(ids) {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        await fetch(`${BaseUrl}/api/locations/locations/?ids=${ids}`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let options = []
                    data.map(location => {
                        options.push({ label: location.name, value: location.id })
                    })

                    let DestinationsLocationGroup = [
                        {
                            label: "Locations",
                            options: options
                        }
                    ];
                    if (this._isMounted) {
                        this.setState({ DestinationsLocationGroup: DestinationsLocationGroup })
                    }
                },
                (error) => {
                    console.log(error, 'error--------------')
                }
            )
    }
    // async loadDestinationsLocationData(ids) {
    //     console.log(ids, "fssss");
    //     const requestOptions = {
    //         method: "GET",
    //         headers: { "Content-Type": "application/json" },
    //     };
    
    //     try {
    //         const response = await fetch(`${BaseUrl}/api/locations/locations/?ids=${ids}`, requestOptions);
    
    //         if (!response.ok) {
    //             throw new Error(`HTTP error! Status: ${response.status}`);
    //         }
    
    //         const data = await response.json();
    //         console.log(data, "API DATA"); // Debugging log
    
    //         // Extract parent details, ensuring no duplicates
    //         const destinations = data
    //             .map(location => location.parent)
    //             .filter((parent, index, self) => parent && self.findIndex(p => p.id === parent.id) === index); // Ensure unique parents by id
    
    //         // Map the unique parents into the options array
    //         let options = destinations.map(parent => ({
    //             label: parent.name,
    //             value: parent.id,
    //         }));
    
    //         let DestinationsLocationGroup = [
    //             {
    //                 label: "Destinations",
    //                 options: options,
    //             },
    //         ];
    
    //         // If using component state
    //         if (this._isMounted) {
    //             this.setState({ DestinationsLocationGroup });
    //         }
    //     } catch (error) {
    //         console.error("Error fetching destination locations:", error);
    //     }
    // }

    async loadAllUsersData() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };

        await fetch(`${BaseUrl}/api/accounts/users/`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let options = []
                    data.map(user => {
                        options.push({ label: user.first_name + " " + user.last_name, value: user.id })
                    })

                    let UsersGroup = [
                        {
                            label: "Users",
                            options: options
                        }
                    ];
                    if (this._isMounted) {
                        this.setState({ UsersGroup: UsersGroup })
                    }
                },
                (error) => {
                    console.log(error, 'error--------------')
                }
            )
    }


    async loadDestinationData(filer_queryset) {
    
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let options = []
                    data.results.map(destination => {
                        options.push({ label: destination.name, value: destination.id })
                    })

                    let DestinationGroup = [
                        {
                            label: "Destination",
                            options: options
                        }
                    ];
                    if (this._isMounted) {
                        this.setState({ DestinationGroup: DestinationGroup })
                    }

                },
                (error) => {
                    console.log(error, 'error--------------')
                }
            )
    }

    async loadLocationData(url) {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(url, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let options = []
                    data.results.map(location => {
                        options.push({ label: location.name, value: location.id })
                    })

                    let LocationsGroup = [
                        {
                            label: "Locations",
                            options: options
                        }
                    ];
                    if (this._isMounted) {
                        this.setState({ LocationsGroup: LocationsGroup })
                    }
                },
                (error) => {
                    console.log(error, 'error--------------')
                }
            )
    }

    // Handle
    // highest hotel price new code 
    // async fetchHotelData() {
    //     const id = this.props.match.params.id;
    //     const requestOptions = {
    //       method: 'GET',
    //       headers: { 
    //         'Content-Type': 'application/json', 
    //         'Authorization': `Bearer ${this.obj.access}` 
    //       },
    //     };
      
    //     try {
    //       const response = await fetch(`${BaseUrl}/api/itineraries/itinerary-hotels/?itinerary__id=${id}`, requestOptions);
    //       if (!response.ok) throw new Error('Failed to fetch hotel data');
    //       const hotelData = await response.json();
          
    //       // Calculate highest margin_price
    //       const hotelPrices = hotelData.map(hotel => parseFloat(hotel.margin_price));
    //       const hotelTotal = hotelData.length > 0 ? Math.max(...hotelPrices) : 0;
    //       this.handleHotelTotal(hotelTotal); // Update state.hotel_total
    //     } catch (error) {
    //       console.error('Error fetching hotel data:', error);
    //       toastr.error('Failed to load hotel costs');
    //     }
    //   }




      
    handleDoubleClick = () => {
        this.setState({ isEditable: true });
      };
    
      handleBlur = () => {
        this.setState({ isEditable: false });
      };
      
    onLocationInputChange(e) {
        this.loadLocationData(`${BaseUrl}/api/locations/location/locations/?search=${e}&size=50`)
    }

    handleSelectedPackegeType = selectedPackegeType => {
        this.setState({ selectedPackegeType })
    }

    handleselectedPickupLocation = selectedPickLocation => {
        this.setState({ selectedPickLocation })
    }

    handleselectedDropOffLocation = selectedDropLocation => {
        this.setState({ selectedDropLocation })
    }

    handleselectedStartDate = selectedStartDate => {
        this.setState({ selectedStartDate })
    }

    handleSelectedStatus = selectedStatus => {
        const { bookingDate } = this.state;
      
        // Create a new state object
        const newState = { selectedStatus };
      
        // Automatically set booking date when status changes to "tour booked"
        if (selectedStatus.value === "tour booked") {
          // Only set bookingDate if it's not already set
          if (!bookingDate) {
            newState.bookingDate = new Date(); // Set to current date/time
          }
        } else {
          // Clear bookingDate if status is not "tour booked"
          newState.bookingDate = null;
        }
      
        // Update the state
        this.setState(newState);
      };
    handleSelectedUser = selectedUser => {
        this.setState({ selectedUser })
    }


    handleActivityTotal(total) {
        this.setState({ activity_total: total })
    }

    handleHotelTotal(total) {
        this.setState({ hotel_total: total });
      }

    handleVehicleTotal(total) {
        this.setState({ vehicle_total: total })
    }

    // Accept date and Call Update Itinerary API 
    // SaveItineraryData(data) {
    //     const { itinerary } = this.state
    //     const requestOptions = {
    //         method: 'PUT',
    //         headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    //         body: JSON.stringify(data)

    //     };
    //     fetch(`${BaseUrl}/api/itineraries/itineraries/${itinerary.id}/`, requestOptions)
    //         .then(res => {
    //             if (res.status >= 400) {
    //                 res.json()
    //                     .then(
    //                         (data) => {
    //                             console.log(data, "---data")
    //                             toastr.error("Something Went Wrong", "")
    //                             this.setState({ loading: false, add_payment_url_loading: false, model_payment_url: false })
    //                         }
    //                     )
    //             }
    //             else {
    //                 this.loadData()
    //                 this.setState({ loading: false, add_payment_url_loading: false, model_payment_url: false, is_load: true })
    //             }
    //         }
    //         )
    // }
    SaveItineraryData = async (data) => {
        try {
            this.setState({ loading: true });
    
            const response = await fetch(
                `${BaseUrl}/api/itineraries/itineraries/${this.state.itinerary.id}/`,
                {
                    method: 'PUT',
                    headers: { 
                        'Content-Type': 'application/json', 
                        'Authorization': `Bearer ${this.obj.access}`
                    },
                    body: JSON.stringify(data)
                }
            );
    
     
    
            // ✅ Trigger re-render by updating the state
            await this.loadData();  
            this.setState({ is_load: true });
    
   
    
        } catch (error) {
            console.error("Save error:", error);
            toastr.error("Update failed, please try again.");
        } finally {
            this.setState({ loading: false });
        }
    };
    

// Add this helper method to your component
stopLoading = () => {
  this.setState({ 
    loading: false, 
    add_payment_url_loading: false 
  });
}

    handlePaymentUrlSubmit(e, values) {
        let payment_note = document.getElementById("payment_note").value
        this.setState({ add_payment_url_loading: true })
        let data = { "payment_url": values.payment_url,'payment_note': payment_note}
        this.SaveItineraryData(data)

    }

    handleSubmit(e, values) {

console.log("FFFFs")
e.preventDefault();
        if (this.childRef.current) {
            this.childRef.current.loadFunc();  // Call child function on submit
        }

        let note = document.getElementById("note").value
        const { selectedDropLocation, selectedPickLocation, selectedStartDate, selectedendDate, selectedPackegeType,
            selectedStatus, selectedUser,bookingDate } = this.state
        if (selectedStartDate === null || selectedendDate === null) {
            toastr.error("Please Select Tour Start Date and End Date", "")
        } else if (selectedDropLocation.value === null || selectedPickLocation.value === null) {
            toastr.error("Please Select Pick up and Drop Off Location", "")
        } else {
            this.setState({ loading: true })
            let data = {
                status: selectedStatus.value,
                // Only include booking_date if status is "tour booked" and bookingDate is valid
                ...(selectedStatus.value === "tour booked" && bookingDate instanceof Date
                  ? { booking_date: bookingDate.toISOString().split('T')[0]  }
                  : {}),
              };
            let dateDiff = getDifferenceInDays(selectedStartDate, selectedendDate)
            let title = values.name + ` Tour Package ${dateDiff}N/${dateDiff + 1}Day Ex ${selectedPickLocation.label} (${values.customer_name})`
            data["title"] = title
            data["name"] = values.name
            data["customer_name"] = values.customer_name
            data["phone"] = values.phone
            data["email"] = values.email
            data["address"] = values.address
            data["zip_code"] = values.zip_code
            data["packege"] = selectedPackegeType.value
            data["start_date"] = `${selectedStartDate.getFullYear()}-${selectedStartDate.getMonth() + 1}-${selectedStartDate.getDate()}`
            data["end_date"] = `${selectedendDate.getFullYear()}-${selectedendDate.getMonth() + 1}-${selectedendDate.getDate()}`
            data["pick_up_location"] = selectedPickLocation.value
            data["drop_off_location"] = selectedDropLocation.value
            data["created_by"] = selectedUser.value
            data["status"] = selectedStatus.value
            data["pax"] = values.pax
            data["note"] = note
            if (selectedStatus.value === "tour booked") {
                data.tour_booked_date = new Date().toISOString(); // Send to API
              }
            this.SaveItineraryData(data)
            this.sendNotification()
        }
    }

    sendNotification() {
        const { itinerary } = this.state
        let note = document.getElementById("note").value
        let notify = document.getElementById("notify").checked

        if (notify) {
            let data = {
                "name": itinerary.created_by.first_name,
                "data": note,
                "subject": `Notification for ${itinerary.name}`,
                "email": itinerary.created_by.email
            }
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                body: JSON.stringify(data)

            };
            fetch(`${BaseUrl}/api/itineraries/send-notification/`, requestOptions)
                .then(res => {
                    if (res.status >= 400) {
                        res.json()
                            .then(
                                (data) => {
                                    console.log(data, "---data")
                                    document.getElementById("notify").checked = false
                                }
                            )
                    }
                    else {
                        toastr.success(`Notification Send to ${itinerary.created_by.first_name}`)
                        document.getElementById("notify").checked = false

                    }
                }
                )



        }

    }


    render() {
        const { itinerary } = this.state
        const { isEditable } = this.state;
        let breadcrumbItems = [
            { title: "Itineraries", link: "/itineraries" },
            { title: itinerary ? itinerary.name : "Itinerary Detail", link: "#" },
            
        ]

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
                        {!isEmpty(this.state.itinerary) ? (
                            <>
                                {/* --------------------------------  Itinerary Section ----------------------------------- */}
                                <Row>
                                    <div className="timeline-block my-3">
                                        <div className="time-show-btn mt-0">

                                            {has_Permission(this.obj.user, 0, 'edit') ?
                                                <Link to={`/itinerary-daily-plan/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-clipboard-list font-size-15"></i> Itinerary Plan</Link>
                                                : null
                                            }
                                           
                                            {has_Permission(this.obj.user, 7, 'read') ?
                                                <Link to={`/itinerary-payment-detail/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-rupee-sign font-size-15"></i> Payments</Link>
                                                : null
                                            }

                                            {has_Permission(this.obj.user, 7, 'read') ?
                                                <Link to={`/invoices/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-file-invoice-dollar font-size-15"></i> Invoices</Link>
                                                : null}
                                            {has_Permission(this.obj.user, 1, 'edit') ?
                                                <Link to={`/itinerary-terms-&-condition/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className=" far fa-list-alt font-size-15"></i> Terms & Conditions</Link>
                                                : null}
                                            {has_Permission(this.obj.user, 1, 'edit') ?
                                                <Link to="#" onClick={this.tog_payment_url} className="btn btn-link btn-rounded w-lg me-2"><i className="fab fa-paypal font-size-15"></i> Online Payment URL</Link>
                                                : null}
                                             <Link to={`/itinerary/${itinerary.id}/${createSlugfromName(itinerary.name)}`} target="_blank" className="btn btn-link btn-rounded w-lg"><i className="far fa-eye font-size-15"></i> View Itinerary</Link>
                                        </div>
                                    </div>
                                </Row>
                                <Row>
                                    <Col lg="12">
                                        <Card>
                                            <CardBody>
                                                <h4 className="card-title mb-4">{itinerary.title} Details</h4>

                                                <AvForm className="needs-validation" id="itinerary" onValidSubmit={this.handleSubmit} >
                                                    <Row>
                                                        <Col md={6}>
                                                            <Row>
                                                                <Col md="6">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label " htmlFor="name">Name</Label>
                                                                        <AvField
                                                                            name="name"
                                                                            value={itinerary.name}
                                                                            type="text"
                                                                            errorMessage="Enter Itinerary Name"
                                                                            className="form-control"
                                                                            validate={{ required: { value: true } }}
                                                                            id="name"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="6">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label " htmlFor="customer_name">Customer Name</Label>
                                                                        <AvField
                                                                            name="customer_name"
                                                                            value={itinerary.customer_name}
                                                                            type="text"
                                                                            errorMessage="Enter Customer Name"
                                                                            className="form-control"
                                                                            validate={{ required: { value: true } }}
                                                                            id="customer_name"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Row>
                                                                <Col md={4}>
                                                                    <div className="mb-3">
                                                                        <AvField
                                                                            name="phone"
                                                                            label="Contact Number"
                                                                            value={itinerary.phone}
                                                                            type="text"
                                                                            validate={{
                                                                                required: { value: true },
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={4}>
                                                                    <div className="mb-3">
                                                                        <Label className="form-label " htmlFor="email">Email</Label>
                                                                        <AvField
                                                                            name="email"
                                                                            value={itinerary.email}
                                                                            type="email"
                                                                            errorMessage="Enter Customer Name"
                                                                            className="form-control"
                                                                            validate={{ required: { value: true } }}
                                                                            id="email"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={4}>

                                                                    <div className="mb-3 form-floating">

                                                                        <AvField
                                                                            name="zip_code"
                                                                            label="Pin/Zip Code"
                                                                            value={itinerary.zip_code}
                                                                            type="number"
                                                                            validate={{
                                                                                pattern: {
                                                                                    value: "^[0-9]+$",
                                                                                    errorMessage: "Only Digits"
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col md="6">
                                                            <div className="mb-3">
                                                                <Label className="form-label " htmlFor="address">Address</Label>
                                                                <AvField
                                                                    name="address"
                                                                    value={itinerary.address}
                                                                    type="text"
                                                                    errorMessage="Enter Address"
                                                                    className="form-control"
                                                                    id="address"
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Row>
                                                                <Col md="4">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Packege Type</Label>
                                                                        <Select
                                                                            value={this.state.selectedPackegeType}
                                                                            onChange={this.handleSelectedPackegeType}
                                                                            options={PackegeTypeGroup}
                                                                            classNamePrefix="select2-selection"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="4">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Pickup Location</Label>
                                                                        <Select
                                                                            onInputChange={this.onLocationInputChange}
                                                                            value={this.state.selectedPickLocation}
                                                                            onChange={this.handleselectedPickupLocation}
                                                                            options={this.state.LocationsGroup}
                                                                            classNamePrefix="select2-selection"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="4">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Drop off Location</Label>
                                                                        <Select
                                                                            onInputChange={this.onLocationInputChange}
                                                                            value={this.state.selectedDropLocation}
                                                                            onChange={this.handleselectedDropOffLocation}
                                                                            options={this.state.LocationsGroup}
                                                                            classNamePrefix="select2-selection"
                                                                        />
                                                                    </div>
                                                                </Col>



                                                            </Row>
                                                        </Col>


                                                    </Row>
                                                    <Row>

                                                        <Col md={4}>
                                                            <Row>

                                                                 <Col md="4">
                                                                   {/* <div className="mb-3">
                                                                     <Label className="form-label">Booking Date</Label>
                                                                     <DatePicker
                                                                       className="form-control"
                                                                       selected={this.state.bookingDate}
                                                                       disabled
                                                                       readOnly
                                                                     />
                                                                   </div> */}
                                                                   <div className="mb-3">
                                                                   <Label className="form-label">Booking Date</Label>
                                                                   {this.state.isTourBookedConfirmed ? (
                                                                     // Show DatePicker with booking date if booked
                                                                     <DatePicker
                                                                       className="form-control"
                                                                       selected={this.state.bookingDate}
                                                                       disabled
                                                                       readOnly
                                                                       dateFormat="dd/MM/yyyy"
                                                                     />
                                                                   ) : (
                                                                     // Show empty disabled input if not booked
                                                                     <input
                                                                       type="text"
                                                                       className="form-control"
                                                                       disabled
                                                                       readOnly
                                                                       value=""
                                                                     />
                                                                   )}
                                                                 </div>
                                                                 </Col>
                                                                <Col md="4">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="start_date">Start Date</Label>
                                                                        <DatePicker
                                                                            className="form-control"
                                                                            minDate={new Date()}
                                                                            selected={this.state.selectedStartDate}
                                                                            onChange={(date) => this.handleselectedStartDate(date)}
                                                                            selectsStart
                                                                            startDate={new Date()}
                                                                            placeholderText="Select Start Date"
                                                                            dateFormat="dd/MM/yyyy"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="4">
                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="end_date">End Date</Label>
                                                                        <DatePicker
                                                                            className="form-control"
                                                                            selected={this.state.selectedendDate}
                                                                            onChange={(date) => this.setState({ selectedendDate: date })}
                                                                            selectsEnd
                                                                            startDate={this.state.selectedStartDate}
                                                                            minDate={this.state.selectedStartDate}
                                                                            placeholderText="Select End Date"
                                                                            dateFormat="dd/MM/yyyy"
                                                                        />
                                                                    </div>
                                                                </Col>

                                                            </Row>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <div className="mb-3">
                                                                        <AvField
                                                                            name="destination_count"
                                                                            label="NO. Of Destinations"
                                                                            type="number"
                                                                            value={this.state.itinerary.destinations ? this.state.itinerary.destinations.length : 0}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </Col>

                                                                <Col md={6}>
                                                                    <div className="mb-3">
                                                                        <AvField
                                                                            name="pax"
                                                                            label="No of Pax"
                                                                            value={this.state.pax}
                                                                            disabled
                                                                            // onChange={e => this.setState({ pax: e.target.value })}
                                                                            // type="number"
                                                                            // validate={{
                                                                            //     pattern: {
                                                                            //         value: "^[0-9]+$",
                                                                            //         errorMessage: "Only Digits"
                                                                            //     }
                                                                            // }}
                                                                        />
                                                                    </div>
                                                                </Col>


                                                            </Row>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Row>

                                                                <Col md={6}>
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Status</Label>
                                                                        <Select
                                                                            value={this.state.selectedStatus}
                                                                            onChange={this.handleSelectedStatus}
                                                                            options={StatusGroup}
                                                                            classNamePrefix="select2-selection"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <div className="mb-3">
                                                                        <Label className="form-label">Assign To</Label>
                                                                        <Select
                                                                            value={this.state.selectedUser}
                                                                            onChange={this.handleSelectedUser}
                                                                            options={this.state.UsersGroup}
                                                                            classNamePrefix="select2-selection"

                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                    <div className="mb-3">
                                                    <label htmlFor="note" className="form-label">Note</label>
                                                    <textarea 
                                                      className={`form-control ${!isEditable ? 'bg-light' : ''}`}
                                                      id="note"
                                                      rows="2"
                                                      defaultValue={itinerary?.note}
                                                      placeholder="Note"
                                                      readOnly={!isEditable}
                                                      onDoubleClick={this.handleDoubleClick}
                                                      onBlur={this.handleBlur}
                                                      style={{ cursor: !isEditable ? 'pointer' : 'auto' }}
                                                    />
                                                    </div>
                                                    </Row>
                                                    <Row>
                                                        <Col md={4} className="mt-3">
                                                            <div className="form-check mb-3">
                                                                <Input className="form-check-input" type="checkbox" value="" id="notify" />
                                                                <Label className="form-check-label" htmlFor="notify">
                                                                    Notity
                                                                </Label>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    {this.obj.user.role === 1 || this.state.itinerary.role === "tour completed" ?
                                                        null
                                                        :
                                                        <Row>
                                                            <Col md="6">

                                                            </Col>
                                                            <Col md="6">
                                                                <Row>
                                                                    <Col md="6">

                                                                    </Col>
                                                                    <Col md="6">
                                                                        {this.state.loading ?
                                                                            <Spinner className="me-2 mt-3 float-end" color="primary" />
                                                                            :
                                                                            <div className="text-center mt-3 float-end">
                                                                                <Button type="submit" color="primary" className="me-1">
                                                                                    Update
                                                                                </Button>
                                                                            </div>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    }

                                                </AvForm>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                {/* --------------------------------  Total Section ----------------------------------- */}
                                <Breadcrumbs title={`${this.state.itinerary.packege} Package Cost`} breadcrumbItems={[]} />

                                <PackageCost
                                    data={this.state.itinerary}
                                    hotel_total={this.state.hotel_total}
                                    vehicle_total={this.state.vehicle_total}
                                    activity_total={this.state.activity_total}
                                    SaveItineraryData={this.SaveItineraryData}
                                    user={this.obj.user}
                                    access={this.obj.access}
                                    is_load={this.state.is_load}

                                />

                                {/* --------------------------------  PAX Section ----------------------------------- */}
                                <Breadcrumbs title="PAX Details" breadcrumbItems={[]} />

                                <PaxDetail
                                    data={this.state.itinerary}
                                    user={this.obj.user}
                                    access={this.obj.access}
                                    
                                />

                                {/* --------------------------------  Destination Section ----------------------------------- */}
                                <Breadcrumbs title="Destination Details" breadcrumbItems={[]} />

                                <DestinationDetail
                                    data={this.state.itinerary}
                                    DestinationGroup={this.state.DestinationGroup}
                                    SaveItineraryData={this.SaveItineraryData}
                                    user={this.obj.user}
                                    access={this.obj.access}
                                    loadData={this.loadData}

                                />



                                {/* --------------------------------  Hotels Section ----------------------------------- */}
                                <Breadcrumbs title="Hotel Details" breadcrumbItems={[]} />

                                <HotelsDetail
                                    ref={this.childRef} 
                                    data={this.state.itinerary}
                                    handleHotelTotal={this.handleHotelTotal}
                                    user={this.obj.user}
                                    access={this.obj.access}
                                    history={this.props.history}
                                />

                                {/* --------------------------------  Vehicle Section ----------------------------------- */}

                                <Breadcrumbs title="Vehicle Details" breadcrumbItems={[]} />

                                <VehicleDetail
                                    data={this.state.itinerary}
                                    DestinationGroup={this.state.DestinationGroup}
                                    handleVehicleTotal={this.handleVehicleTotal}
                                    user={this.obj.user}
                                    obj={this.obj}
                                    history={this.props.history}

                                />

                                {/* --------------------------------  Vehicle Section ----------------------------------- */}
                                <Breadcrumbs title="Activity Details" breadcrumbItems={[]} />

                                <ActivityDetail
                                    data={this.state.itinerary}
                                    location={this.state.DestinationsLocationGroup}
                                    handleActivityTotal={this.handleActivityTotal}
                                    user={this.obj.user}
                                    access={this.obj.access}
                                    history={this.props.history}
                                />


                                {/* --------------------------------  Activitry Section ----------------------------------- */}

                                <ActivityLog
                                    itinerary={this.state.itinerary}
                                    user={this.obj.user}
                                    access={this.obj.access}
                                    history={this.props.history}
                                />
                            </>
                        ) : (
                            <div className="d-flex align-items-center justify-content-center min-vh-100">

                                <Spinner type="grow" className="me-2" color="secondary" />
                                <Spinner type="grow" className="me-2" color="secondary" />
                                <Spinner type="grow" className="me-2" color="secondary" />
                                <Spinner type="grow" className="me-2" color="secondary" />

                            </div>
                        )}

                    </Container>
                </div>
                <Col sm={6} md={4} xl={3} className="mt-4">

                    <Modal
                        isOpen={this.state.model_payment_url}
                        toggle={this.tog_payment_url}
                        centered={true}
                    >
                        <ModalHeader toggle={this.tog_payment_url}>
                            Online Payment URL
                        </ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handlePaymentUrlSubmit} >
                                <Row>

                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="payment_url">{"Online Paymant URL"}</Label>
                                            <AvField
                                                name="payment_url"
                                                type="text"
                                                placeholder="Enter Online Payment URL"
                                                value={itinerary.payment_url}
                                                className="form-control"
                                                // validate={{ required: { value: true } }}
                                                id="payment_url"

                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label " htmlFor="payment_note">Note</Label>
                                            <Input
                                                name='note'
                                                type="textarea"
                                                id="payment_note"
                                                rows="3"
                                                placeholder="Note"
                                                defaultValue={itinerary.payment_note}
                                            />
                                        </div>
                                    </Col>
                                </Row>


                                <FormGroup className="mb-0 mt-3">
                                    {this.state.add_payment_url_loading ? (
                                        <Spinner className="me-2 mt-2" color="primary" />
                                    ) : (
                                        <Button type="submit" color="primary" className="me-1">
                                            Save
                                        </Button>

                                    )}
                                </FormGroup>
                            </AvForm>

                        </ModalBody>
                    </Modal>
                </Col>
            </React.Fragment>
        );
    }
}

export default ItineraryDetail;

